<template functional>
  <div class="loading--circle">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  created() {
    console.log("loading.vue created");
  }
};
</script>

<style lang="scss" scoped>
.loading {
  &--circle {
    height: 70px;
    width: 70px;
    background-color: #0f74bd;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    span {
      transition: all 500ms ease;
      background: #4a72da;
      box-shadow: 1px 2px 3px #999;
      height: 5px;
      width: 5px;
      margin: 3px;
      display: inline-block;
      border-radius: 10px;
      animation: wave 2s ease infinite;
    }

    span:nth-child(1) {
      animation-delay: 0ms;
    }
    span:nth-child(2) {
      animation-delay: 100ms;
    }
    span:nth-child(3) {
      animation-delay: 200ms;
    }
  }
}

@keyframes wave {
  0%,
  40%,
  100% {
    transform: translate(0, 0);
    background-color: white;
  }
  10% {
    transform: translate(0, -15px);
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/info/statuses/loading.vue